<template>
  <div>
    <div v-if="this.$store.state.device.isMobile" style="height: 100vh; background-color: #1e90ff; background-image: linear-gradient(to top, #2B2D42, #1e90ff 25%)">
      <img class="logo" src="../../public/img/512.png">
      <div class="b-form">
        <b-form>
          <b-form-group style="margin-bottom: 10%">
            <legend>{{ $t('pages.resetPassword.new_password') }}</legend>
            <b-form-input
                    class="input"
                    v-model="form.new_password"
                    type="password"
                    required
            ></b-form-input>
          </b-form-group>

          <b-form-group style="margin-bottom: 1.5%;">
            <legend>{{ $t('pages.resetPassword.confirm_password') }}</legend>
            <b-form-input
                    class="input"
                    v-model="form.confirm_password"
                    type="password"
                    required
            ></b-form-input>
          </b-form-group>
          <b-button v-on:click="resetPassword" class="btnLogin" style="padding: 0;">{{ $t('pages.resetPassword.reset') }}</b-button>
          <div style="padding-top: 5%; padding-bottom: 10%;">
            <a @click="changeToPt" class="lang" v-bind:style="[pt==true ? {'color': '#2B2D42', 'font-weight': '700'} : {'color': 'white'}]">PT</a>
            <span class="lang_seperator" style="color: white;">|</span>
            <a @click="changeToEn" class="lang" v-bind:style="[en==true ? {'color': '#2B2D42', 'font-weight': '700'} : {'color': 'white'}]">EN</a>
          </div>
        </b-form>
      </div>
    </div>
    <div v-if="this.$store.state.device.isDesktop" style="height: 100vh; background-color: #1e90ff; background-image: linear-gradient(to top, #2B2D42, #1e90ff 50%)">
      <div class="main">
        <div class="b-form-desktop">
          <img class="logo_desktop" src="../../public/img/512.png">
          <b-form>
            <br>
            <b-form-group style="margin-bottom: 10%">
              <legend>{{ $t('pages.resetPassword.new_password') }}</legend>
              <b-form-input
                      class="input"
                      v-model="form.new_password"
                      type="password"
                      required
              ></b-form-input>
            </b-form-group>

            <b-form-group style="margin-bottom: 1.5%;">
              <legend>{{ $t('pages.resetPassword.confirm_password') }}</legend>
              <b-form-input
                      class="input"
                      v-model="form.confirm_password"
                      type="password"
                      required
              ></b-form-input>
            </b-form-group>
            <br>
            <b-button v-on:click="resetPassword" class="btnLogin">{{ $t('pages.resetPassword.reset') }}</b-button>
            <div style="padding-top: 5%; padding-bottom: 10%;">
              <a @click="changeToPt" class="lang" v-bind:style="[pt==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': '#2B2D42'}]">PT</a>
              <span class="lang_seperator">|</span>
              <a @click="changeToEn" class="lang" v-bind:style="[en==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': '#2B2D42'}]">EN</a>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {resetPassword} from "../api/Auth/apiAuth";
  import {mutations} from "../store/modules/device";
  export default {
    name: "login",
    data() {
      return {
        form: {
          new_password: "",
          confirm_password: ""
        },
        pt: null,
        en: null
      };
    },
    methods: {
      changeToEn: function() {
        this.$i18n.set('en');
        this.en = true;
        this.pt = false;
      },
      changeToPt: function() {
        this.$i18n.set('pt');
        this.en = false;
        this.pt = true;
      },
      resetPassword: function() {
        let spinner = this.$loading.open();
        let reset_password_data = {
          new_password: this.form.new_password,
          token: this.$route.query.token
        };
        if(this.form.new_password == this.form.confirm_password) {
          resetPassword(reset_password_data)
            .then(response => {
              spinner.close();
              if(response.data.type=="error") {this.new_password=''; this.confirm_password=''; this.$toast.open({message: 'As passwords não coincidem. Por favor insira novamente', type: 'is-danger', duration: 4000});};
              if(response.data.type=="success") {this.new_password=''; this.confirm_password=''; this.$toast.open({message: 'Password atualizada'}); this.$router.push('/')};
            })
            .catch(error => {
              spinner.close();
              if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
              else this.$toast.open({message: error.response.data.code, type: 'is-danger'});
            })
        } else {spinner.close();this.new_password=''; this.confirm_password=''; this.$toast.open({message: 'As passwords não coincidem. Por favor insira novamente', type: 'is-danger', duration: 4000});}
        
      }
    },
    mounted() {
      if(this.$i18n.locale()=='pt') this.pt=true;
      if(this.$i18n.locale()=='en') this.en=true;
    }
  };
</script>

<style scoped>
  .lang {
    letter-spacing: 0.8px;
    font-size: 100%;
  }
  .lang_seperator {
    margin: 10px;
    color: #2B2D42;
  }
  input {
    text-align: center;
  }
  @media (max-height: 750px) {
    .logo{
      width: 40%;
      padding-top: 10%;
      position: relative;
    }
  }
  @media (min-height: 750px) {
    .logo{
      width: 40%;
      padding-top: 20%;
      padding-bottom: 5%;
      position: relative;
    }
  }
  @media(max-width: 425px){
    .b-form {
      bottom: 0;
      margin: 10% 10% 10% 10%;
    }
    .btnLogin {
      height: 55px;
      width: 100%;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      margin-top: 20%
    }
    .input {
      background: white;
      border-radius: 32px;
      height: 47px;
    }
    legend {
      color: white;
      text-align: left;
      font-size: 16px;
      letter-spacing: 0.8px;
      margin-bottom: 2%;
    }
    .forgot {
      color: #ffffff;
      text-decoration: underline;
      font-size: 14px;
    }
    a:visited {
      color: white;
    }
  }
  @media(min-width: 425px){
    .b-form {
      bottom: 0;
      margin: 10% 10% 10% 10%;
    }
    .btnLogin {
      height: 55px;
      width: 100%;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
    }
    .input {
      background: white;
      border-radius: 32px;
      height: 47px;
    }
    legend {
      color: #2B2D42;
      text-align: left;
      font-size: 16px;
      letter-spacing: 0.8px;
      margin-bottom: 2%;
    }
  }

  .main {
    width: 30vw;
    height: 75vh;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #ffffff;
    border-radius: 32px;
  }
  @media (max-height: 700px) {
    .logo_desktop{
      width: 30%;
      padding-bottom: 5%;
      padding-top: 5%;
    }
  }
  @media (min-height: 700px) {
    .logo_desktop{
      width: 30%;
      padding-bottom: 6%;
      padding-top: 5%;
    }
  }
  .b-form-desktop {
    width: 80%;
    height: 90%;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
</style>
